import { useState } from "react";
import { KANBAN_COLUMNS, launchBadge } from "@/data/launchOptions";
import { MilestoneCard } from "./MilestoneCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const COL_ACCENT = {
  "Not started": "#94A3B8",
  Planned: "#06B6D4",
  "In progress": "#E0A82E",
  Blocked: "#FB6F5A",
  "Ready for review": "#1D4ED8",
  Complete: "#16A34A",
};

export const MilestoneKanban = ({ milestones, today, depIncompleteFor, onOpen, onStatusChange }) => {
  const [dragId, setDragId] = useState(null);
  const [overCol, setOverCol] = useState(null);

  const handleDrop = (status) => {
    if (dragId && onStatusChange) {
      const m = milestones.find((x) => x.id === dragId);
      if (m && m.status !== status) onStatusChange(dragId, status);
    }
    setDragId(null);
    setOverCol(null);
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="milestone-kanban">
      {KANBAN_COLUMNS.map((col) => {
        const cards = milestones.filter((m) => m.status === col);
        const accent = COL_ACCENT[col] || "#94A3B8";
        return (
          <div
            key={col}
            data-testid={`kanban-col-${col}`}
            onDragOver={(e) => { e.preventDefault(); setOverCol(col); }}
            onDrop={() => handleDrop(col)}
            className={`rounded-2xl border p-3 transition-colors ${overCol === col ? "border-[#E0A82E] bg-[#E0A82E]/5" : "border-[#E4E9F3] bg-white"}`}
          >
            <div className="mb-3 flex items-center justify-between rounded-xl px-2.5 py-1.5" style={{ backgroundColor: `${accent}12` }}>
              <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.1em]" style={{ color: accent }}>
                <span className="h-2 w-2 rounded-full" style={{ backgroundColor: accent }} />{col}
              </span>
              <span className="rounded-full bg-white px-2 py-0.5 text-xs font-bold text-[#5A6B8C] ring-1 ring-[#E4E9F3]">{cards.length}</span>
            </div>
            <div className="space-y-3">
              {cards.map((m) => (
                <div key={m.id}>
                  <MilestoneCard milestone={m} today={today} depIncomplete={depIncompleteFor(m)} draggable={!!onStatusChange} onDragStart={() => onStatusChange && setDragId(m.id)} onOpen={() => onOpen(m)} />
                  {onStatusChange && (
                  <Select value={m.status} onValueChange={(v) => onStatusChange(m.id, v)}>
                    <SelectTrigger data-testid={`kanban-status-${m.id}`} className="mt-1.5 h-7 rounded-full border-[#E4E9F3] bg-white text-[11px]"><SelectValue /></SelectTrigger>
                    <SelectContent>{KANBAN_COLUMNS.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
                  </Select>
                  )}
                </div>
              ))}
              {cards.length === 0 && <p className="px-1 py-6 text-center text-xs text-[#9DAAC6]">Drop milestones here</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
};
